export default __webpack_public_path__ + "static/media/geLogo.d38e2a64.png";